<template lang="pug">
    #ManageUsers    
        loadingOverlay(v-if='loading' message='Loading . . .' :zIndex='999')
        .px-4.py-3
            v-row.align-center(no-gutters)
                v-col(cols='7')
                    v-btn-toggle(v-model.lazy='mangeUserShow' color='primary accent-3' exclusive group @change='changeActive')
                        v-btn.rounded-card.mx-0(:value='true' height='40' :readonly='mangeUserShow') {{$t('MANAGEUSERS.ACTIVATED')}}({{ activeUser }})
                        v-btn.rounded-card.mx-0(:value='false' height='40' :readonly='mangeUserShow') {{$t('MANAGEUSERS.UNACTIVATED')}}({{ unactiveUser }})
                v-col(cols='5').d-flex
                    v-text-field.pa-0.pt-1.mr-4(v-model='searchMangeUser' flat dense height='30' min-height='30' prepend-inner-icon='icon-search')
                    v-btn(@click='showAddUserDialog' height='40' color='#14C6DE' depressed dark)
                        v-icon.mr-1(size='14') icon-add
                        span {{$t('MANAGEUSERS.INVITE_USERS')}} 
            v-data-table.dashboard-table(
                :headers='mangeUserHeaders' 
                :items='mangeUserListData' 
                :items-per-page='itemPerPage' 
                :page.sync='page' 
                :item-class="rowClass"
                fixed-header 
                @page-count='pageCount = $event' 
                :search='searchMangeUser' 
                multi-sort
                max-height='70vh'
                height='70vh'
                :header-props="{sortIcon: 'mdi mdi-arrow-up'}"  
                hide-default-footer='hide-default-footer' 
                dense
            )
                template(v-slot:item.is_service_agent='{ item }')
                    v-checkbox.v-input__slot_checkbox.v-input__slot(v-model="item.usersetting.is_service_agent" hide-details="auto" @change='isActiveAgent(item)' :disabled='$isViewOnly.isViewOnly' color='#14C6DE')
                template(v-slot:item.is_portal_user='{ item }')
                    v-checkbox.v-input__slot_checkbox.v-input__slot(v-model="item.usersetting.is_portal_user" hide-details="auto" @change='isActiveAgent(item)' :disabled='$isViewOnly.isViewOnly' color='#14C6DE') 
                template(v-slot:item.fullName='{ item }')
                    v-list-item
                        v-list-item-avatar.mb-1(color='aliceBlue' size='40')
                            v-img( v-if='item.userPhoto!=null' :src='item.userPhoto')
                            v-icon(v-else) mdi-account
                        v-list-item-content
                            v-row(no-gutters)
                                v-col.text-left(cols='8')
                                    v-list-item-title {{ item.fullName }}
                template(v-slot:item.is_staff='{ item }')
                    span(v-if='item.is_staff === true') {{$t('MANAGEUSERS.MANAGER')}}  
                    span(v-else) {{$t('MANAGEUSERS.STAFF')}} 
                template(v-slot:item.last_login='{ item }')
                    span(v-if='item.last_login' style="white-space: pre-line;") {{ getFormatTime(item.last_login) }}
                template(v-slot:item.active='{ item }')
                    v-btn(icon @click='showEditUserDialog(item)')
                        v-icon(size='18') icon-edit
                    v-btn(icon @click='onResetPassword(item)' v-if='airgapped && item.is_active' :title=`$t('MANAGEUSERS.RESET_PASSWORD')`)
                        v-img(src='@/assets/images/reset_password.svg' max-width='20' max-height='20')
                    v-btn(icon @click='onDelete(item)' v-if='item.is_active')
                        v-icon(size='20') mdi-cancel
                    v-btn(icon @click='onReactive(item)' v-else)
                        v-icon(size='20') mdi-refresh
            v-pagination.py-1.mb-3(v-model='page' :length='pageCount' circle :total-visible="10")
        v-dialog(v-model='mangeUserAddDialog' max-width='480' content-class='statusDialog' v-if='mangeUserAddDialog')
            v-card
                v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('MANAGEUSERS.INVITE_USERS')}}
                v-card-text
                    v-form(v-model='addUser.valid' ref='form')
                        v-row.mt-2
                            v-col.pa-0(cols='2').d-flex.justify-start
                                div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('MANAGEUSERS.MAIL_TITLE')}}
                            v-col.pa-0
                                v-text-field(
                                    v-model='addUser.username',
                                    outlined,
                                    dense
                                    :rules='formRule.emailRules',
                                    required='required',
                                    :hint=`$t('MANAGEUSERS.MAIL')`
                                    persistent-hint
                                )
                        v-row.mt-4
                            v-col.pa-0.mt-3(cols='2').d-flex.justify-start
                                div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('MANAGEUSERS.USER')}}
                            v-col.pa-0
                                v-row(no-gutters)
                                    v-col.pr-2(cols='4')
                                        v-row(no-gutters)
                                            div(style='color:#444444; font-weight: 400; font-size: 12px;') {{$t('MANAGEUSERS.LAST_NAME')}}
                                        v-text-field(
                                            v-model='addUser.last_name',
                                            outlined,
                                            dense,
                                            :placeholder="$t('MANAGEUSERS.LAST_NAME')"
                                            :rules='formRule.nameRules'
                                        )
                                    v-col.pl-2
                                        v-row(no-gutters)
                                            div(style='color:#444444; font-weight: 400; font-size: 12px;') {{$t('MANAGEUSERS.FIRST_NAME')}}
                                        v-text-field(
                                            v-model='addUser.first_name',
                                            outlined,
                                            dense,
                                            :placeholder="$t('MANAGEUSERS.FIRST_NAME')"
                                            :rules='formRule.firstNameRules'
                                        )
                        v-row.mt-2
                            v-col.pa-0(cols='2').d-flex.justify-start
                                div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('MANAGEUSERS.USER_ROLE')}}
                            v-col.pa-0
                                v-select(
                                    v-model='addUser.is_staff',
                                    :items="manageRoleList",
                                    item-value="value",
                                    item-text="text",
                                    outlined,
                                    dense
                                )
                        v-row.mt-2.mb-4
                            v-checkbox(v-model='addUser.is_portal_user' color='#14C6DE' hide-details='auto' style='margin-top: 0px !important; padding-top: 0px !important;')
                                template(v-slot:label)
                                    span(style="margin-left: 8px") {{ $t('MANAGEUSERS.IS_PORTAL_USER_ADD') }}
                    div.d-flex.align-center.justify-end(style='background-color: #f4f4f4; width: 480px; height:60px; margin-left:-24px; margin-bottom: -20px;')
                        v-btn.mr-4(
                            :ripple="false",
                            @click="onCancel",
                            width="100",
                            height="40",
                            color="cancel",
                            depressed,
                            outlined,
                            style='font-weight: 700;'
                        ) {{$t('GENERAL.CANCEL')}}
                        v-btn.mr-6(
                            :ripple="false",
                            @click="onUserAdd(addUser)",
                            width="100",
                            height="40",
                            color="#14C6DE",
                            depressed,
                            dark,
                            style='font-weight: 700;'
                        ) {{$t('GENERAL.CONFIRM')}}
        v-dialog(v-model='mangeUserEditDialog' max-width='480' content-class='statusDialog' v-if='mangeUserEditDialog')
            v-card
                v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('MANAGEUSERS.EDIT_USER')}}
                v-card-text
                    v-form(v-model='editUser.valid' ref='form')
                        v-row.mt-2
                            v-col.pa-0(cols='2').d-flex.justify-start
                                div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('MANAGEUSERS.MAIL_TITLE')}}
                            v-col.pa-0
                                v-text-field(
                                    v-model='editUser.email',
                                    outlined,
                                    dense
                                    :rules='formRule.emailRules',
                                    required='required',
                                    :hint=`$t('MANAGEUSERS.MAIL')`
                                    persistent-hint
                                )
                        v-row.mt-4
                            v-col.pa-0.mt-3(cols='2').d-flex.justify-start
                                div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('MANAGEUSERS.USER')}}
                            v-col.pa-0
                                v-row(no-gutters)
                                    v-col.pr-2(cols='4')
                                        v-row(no-gutters)
                                            div(style='color:#444444; font-weight: 400; font-size: 12px;') {{$t('MANAGEUSERS.LAST_NAME')}}
                                        v-text-field(
                                            v-model='editUser.last_name',
                                            outlined,
                                            dense,
                                            :placeholder="$t('MANAGEUSERS.LAST_NAME')"
                                            :rules='formRule.nameRules'
                                        )
                                    v-col.pl-2
                                        v-row(no-gutters)
                                            div(style='color:#444444; font-weight: 400; font-size: 12px;') {{$t('MANAGEUSERS.FIRST_NAME')}}
                                        v-text-field(
                                            v-model='editUser.first_name',
                                            outlined,
                                            dense,
                                            :placeholder="$t('MANAGEUSERS.FIRST_NAME')"
                                            :rules='formRule.firstNameRules'
                                        )
                        v-row.mt-2
                            v-col.pa-0(cols='2').d-flex.justify-start
                                div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('MANAGEUSERS.USER_ROLE')}}
                            v-col.pa-0
                                v-select(
                                    v-model='editUser.is_staff',
                                    :items="manageRoleList",
                                    item-value="value",
                                    item-text="text",
                                    outlined,
                                    dense
                                )
                        v-row.mt-2.mb-4
                            v-checkbox(v-model='editUser.is_portal_user' color='#14C6DE' hide-details='auto' style='margin-top: 0px !important; padding-top: 0px !important;')
                                template(v-slot:label)
                                    span(style="margin-left: 8px") {{ $t('MANAGEUSERS.IS_PORTAL_USER_ADD') }}
                    div.d-flex.align-center.justify-end(style='background-color: #f4f4f4; width: 480px; height:60px; margin-left:-24px; margin-bottom: -20px;')
                        v-btn.mr-4(
                            :ripple="false",
                            @click="mangeUserEditDialog = false",
                            width="100",
                            height="40",
                            color="cancel",
                            depressed,
                            outlined,
                            style='font-weight: 700;'
                        ) {{$t('GENERAL.CANCEL')}}
                        v-btn.mr-6(
                            :ripple="false",
                            @click="onUserEdit(editUser)",
                            width="100",
                            height="40",
                            color="#14C6DE",
                            depressed,
                            dark,
                            style='font-weight: 700;'
                        ) {{$t('GENERAL.CONFIRM')}}
        
        v-dialog(v-model='messageDialog' width='360' content-class='statusDialog')
                message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
        v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
                success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
        v-dialog(v-model='errorDialog' width='360' content-class='statusDialog')
                error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
        v-dialog(v-model='resetLinkDialog' max-width='480' content-class='statusDialog')
                copyable-result-dialog(
                    @emitCopyableResultDialog='resetLinkDialog = false'
                    :title=`$t('MANAGEUSERS.RESET_PASSWORD')`
                    :description=`$t('MANAGEUSERS.RESET_LINK_DESC')`
                    :items='resetLinkItems'
                )
        v-dialog(v-model='inviteResultDialog' max-width='480' content-class='statusDialog' persistent)
                copyable-result-dialog(
                    @emitCopyableResultDialog='inviteResultDialog = false'
                    :title=`$t('MANAGEUSERS.INVITED_TITLE')`
                    :description=`$t('MANAGEUSERS.INVITED_DESC')`
                    :items='inviteResultItems'
                )
</template>

<script>
    import Vue from 'vue';
    import { mapActions } from 'vuex';
    import messageDialog from '@/components/Dialog/messageDialog';    
    import PersonalSettingService from "@/services/PersonalSettingService";
    import successDialog from "@/components/Dialog/successDialog";
    import errorDialog from "@/components/Dialog/errorDialog";
    import loadingOverlay from "@/components/Common/loadingOverlay";
    // 邀請按鈕不再依租戶是否為 SSO 隱藏，這支 service 在本檔已無其他用途，一併停用。
    // import PreferenceService from "@/services/PreferenceService";
    import copyableResultDialog from "@/components/Dialog/copyableResultDialog";
    import AirgappedService from "@/services/AirgappedService";
    import passData from "@/services/passData.js";
    import i18n from '/common/plugins/vue-i18n.js' 

    export default Vue.extend({
        props: {  
            
        },
        components: {
            loadingOverlay,
            messageDialog,
            successDialog,
            errorDialog,
            copyableResultDialog,
        },
        data() {
        return {
            loading:false,
            airgapped: false,
            resetLinkDialog: false,
            resetLinkItems: [],
            inviteResultDialog: false,
            inviteResultItems: [],
            activeUser: 0,
            unactiveUser: 0,
            isSuperUser:false,
            reActiveData:{},
            reActiveItemIndex:null,
            reActiveUserID:null,
            reActiveUser:false,
            deleteData:{},
            deleteItemIndex:null,
            deleteUserID:null,
            deleteUser:false,
            userId:null,
            isStaff:false,
            editData:{},
            defultRole:{value:false,text:i18n.t('MANAGEUSERS.STAFF')},
            manageRoleList:[
                {value:true,text:i18n.t('MANAGEUSERS.MANAGER')},
                {value:false,text:i18n.t('MANAGEUSERS.STAFF')}
            ],
            mangeUserListData: [],
            page: 1,
            pageCount: 0,
            itemPerPage: 100,
            mangeUserHeaders: [
                {  text: i18n.t('MANAGEUSERS.NAME'), value: 'fullName', align: 'left'},
                {  text: i18n.t('MANAGEUSERS.ROLE'), value: 'is_staff', align: 'left'},
                {  text: i18n.t('MANAGEUSERS.IS_SERVICE_AGENT'), value: 'is_service_agent', align: 'left' },
                {  text: i18n.t('MANAGEUSERS.IS_PORTAL_USER'), value: 'is_portal_user', align: 'left' },
                {  text: i18n.t('MANAGEUSERS.LAST_TIME'), value: 'last_login', align: 'left'},
                {  text: i18n.t('MANAGEUSERS.ACTIVE'), value: 'active', align: 'left',width: '150px', sortable: false,},
            ],
            searchMangeUser: '',
            mangeUserAddDialog: false,
            addUser : {
                valid: true,
                username:'',
                first_name: '',
                last_name: '',
                is_staff: true,
                email: '',
                is_portal_user: true,
            },
            mangeUserEditDialog: false,
            editUser : {
                valid: true,
                firs_name: '',
                last_name: '',
                is_staff: '',
                email: '',
                is_portal_user: false,
            },			
            mangeUserShow: true,
            errorMessage:"",
            message:"",
            messageDialog:false,
            errorDialog:false,
            successDialog:false,
            valid:false,            
            userData:{},
            max_license:null,
            formRule: {
            fieldRules: [(v) => !!v || i18n.t('RULE.RULE_R')],
            accountRules: [(v) => !!v || i18n.t('RULE.RULE_R_ACCOUNT')],
            nameRules: [
                        (v) => !!v || i18n.t('RULE.RULE_R_LASTNAME_3'),
                        (v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')
                    ],
            firstNameRules: [(v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')],
            emailRules: [(v) => !!v && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|(^$)|null/.test(v) || i18n.t('RULE.RULE_EMAIL')],
            phoneRules: [(v) => /^09\d{8}$|(^$)|null/.test(v) || i18n.t('RULE.RULE_PHONE')],
            
            },
            // 已停用：唯一的用途是控制邀請按鈕的 v-if，按鈕改為一律顯示後沒有任何
            // template 或 method 會讀這個值。
            // isADFS:true,
        }},
        async created()
        {
            await PersonalSettingService.getCurrentUserDetail()
            .then(response =>
            {
                this.userId = response.data[0].id;
            });

            await this.getManageUserList();

            // 已停用：原本用 AUTH_TYPE 判斷是否為 SSO 租戶，藉此隱藏邀請按鈕。
            // SSO 租戶現在也允許邀請使用者（寄不寄信由後端依既有分支決定），
            // 所以這個結果沒人使用。它是 await，留著等於每次進畫面都白等一次
            // GET /preference/?code=AUTH_TYPE 的往返。
            // await PreferenceService.isADFSLogin()
            // .then(response =>{
            //     this.isADFS = response.data === "ADFS";
            // });

            this.resolveAirgapped();
        },
        methods:{
            async resolveAirgapped() {
                const value = await AirgappedService.resolveAirgapped();
                // null 代表查不到，維持 false 不顯示按鈕
                if (value !== null) this.airgapped = value;
            },
            // 地端：產生重設密碼連結交給管理員自行轉交。需求明定不彈確認框，直接執行
            async onResetPassword(item) {
                this.loading = true;
                await PersonalSettingService.generateResetLink(item.id)
                .then(response => {
                    this.resetLinkItems = [{ label: '', value: response.data.reset_url }];
                    this.resetLinkDialog = true;
                })
                .catch(() => {
                    this.errorDialog = true;
                    this.errorMessage = i18n.t('MANAGEUSERS.RESET_LINK_ERROR');
                })
                .finally(() => {
                    this.loading = false;
                });
            },
            async getManageUserList() {
                await PersonalSettingService.getUserDetail()
                .then(response =>
                {
                    if (response.data.userList.length > 0) {
                        this.isStaff = response.data.userList.filter(item=>{return item.id == this.userId})[0].is_staff
                        this.isSuperUser = response.data.userList.filter(item=>{return item.id == this.userId})[0].is_superuser
                        this.max_license = response.data.max_license;
                        this.mangeUserData = response.data.userList;
                        this.mangeUserListData = this.mangeUserData.filter(el => {return el.is_active == true });
                        this.activeUser = this.mangeUserListData.length
                        this.unactiveUser = this.mangeUserData.length - this.activeUser
                        this.mangeUserData.forEach(item => {
                            item.fullName = item.last_name + ' ' + item.first_name
                        });
                        for(var i in this.mangeUserListData)
                        {
                            this.mangeUserListData[i].is_service_agent = this.mangeUserListData[i].usersetting.is_service_agent;
                            this.mangeUserListData[i].is_portal_user = this.mangeUserListData[i].usersetting.is_portal_user;
                            if(this.mangeUserListData[i].usersetting.photo != null)
                            {
                                this.isUserPhoto = true
                                this.mangeUserListData[i].userPhoto = this.mangeUserListData[i].usersetting.photo
                            }
                        }
                    }
                })
                .catch((response) => {
                    this.showErrorDialog(response);
                });
            },
            validateForm(){
                this.valid = this.$refs.form.validate();
                if(this.valid)                    
                    return true;
                else
                    return false;
            },
            showSuccessDialog() {
                this.successDialog = true;
            },
            onEmitSuccessDialog() {
                this.successDialog = false;
             },
            showErrorDialog(message) {  
                this.errorDialog = true;      
                this.errorMessage = message;
            },
            onEmitErrorDialog() {
                this.errorDialog = false;
            },
            showMessageDialog(message) {
                this.messageDialog = true;
                this.message = message;
            },
            ...mapActions([
                'logout',
            ]),
            onEmitMessageDialog(val) {
                this.messageDialog = false; 
                if(val){
                if(this.deleteUser == true){
                    this.changeData=this.mangeUserListData.filter(user=>{return user.id==this.deleteUserID})[0]
                    PersonalSettingService.updateUserDetail(this.deleteData).then(()=>{                        
                        this.mangeUserListData.splice(this.deleteItemIndex,1)
                        this.mangeUserData.find(el => el == this.changeData).is_active = false;     
                        this.activeUser = this.activeUser-1;
                        this.unactiveUser = this.unactiveUser +1; 
                    })                    
                    this.showSuccessDialog()
                    this.deleteUser = false
                    this.deleteData={}
                }
                if(this.reActiveUser == true){
                    this.changeData=this.mangeUserListData.filter(user=>{return user.id==this.reActiveUserID})[0]
                    PersonalSettingService.updateUserDetail(this.reActiveData).then(()=>{                        
                        this.mangeUserListData.splice(this.reActiveItemIndex,1)
                        this.mangeUserData.find(el => el == this.changeData).is_active = true;     
                        this.activeUser = this.activeUser +1;
                        this.unactiveUser = this.unactiveUser -1; 
                    })                    
                    this.showSuccessDialog()
                    this.reActiveUser = false
                    this.reActiveData = {}
                }
                }
            }, 
            changeActive(val) {                
                if (val) {
                    this.mangeUserListData = this.mangeUserData.filter(el => {return el.is_active == true });                
                } else if(val!=undefined) {
                    this.mangeUserListData = this.mangeUserData.filter(el => {return el.is_active == false });
                }
            },
            showAddUserDialog() {
                if(this.activeUser>=this.max_license){
                // if(this.activeUser>=100){
                    this.showErrorDialog(i18n.t('MANAGEUSERS.ERROR'))
                    return 
                }
                this.mangeUserAddDialog = true;
            },
        async onUserAdd(data) {
            if(this.isStaff === false)
            {
                this.showErrorDialog(i18n.t('MANAGEUSERS.ERROR_2'))
                return
            }            
            if(this.mangeUserData.find(el=>el.username == data.username))
            {
                this.showErrorDialog(i18n.t('MANAGEUSERS.ERROR_3'))
                return
            }            
            if(this.validateForm()){
                this.loading = true
                data.email = data.username
                data.fromUpgpt = true;
                data.usersetting = { is_portal_user: data.is_portal_user };
                let lang = window.localStorage.getItem('language');
                await PersonalSettingService.createUserDetail(data,lang).then((response)=>{                  
                if(response.data.last_name)         
                {
                    response.data.fullName = response.data.last_name+' '+response.data.first_name
                    this.mangeUserData.splice(0,0, response.data)
                    this.mangeUserListData.splice(0,0, response.data)
                    this.activeUser = this.activeUser +1;
                    // 地端不寄邀請信，後端改把明文密碼帶回來，直接顯示給管理員轉交。
                    // 以 response 有沒有 temp_password 為準，前端不必自己判斷 airgapped
                    if(response.data.temp_password){
                        this.inviteResultItems = [
                            { label: i18n.t('MANAGEUSERS.INVITED_USERNAME'), value: response.data.username },
                            { label: i18n.t('MANAGEUSERS.INVITED_PASSWORD'), value: response.data.temp_password },
                        ];
                        this.inviteResultDialog = true;
                    }else{
                        this.showSuccessDialog()
                    }
                }
                else{
                    this.showErrorDialog(i18n.t('MANAGEUSERS.ERROR'))
                }
                })
                this.mangeUserAddDialog = false;
                this.loading = false
                this.addUser =  {
                    valid: true,
                    username:'',
                    first_name: '',
                    last_name: '',
                    is_staff: false,
                    email: '',
                    is_portal_user: true,
                }
            }
        },
        getFormatTime(data) {
            let date = new Date(data);
            if (this.$i18n.locale === "zh_TW") {
                let dateStr = date.toLocaleDateString("zh-TW", {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                });

                let weekday = date.toLocaleDateString("zh-TW", {
                weekday: 'long',
                });

                let timeStr = date.toLocaleTimeString("zh-TW", {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
                });

                return `${dateStr} ${weekday} ${timeStr}`;
            } else {
                const dateStr = date.toLocaleDateString("en-US", {
                weekday: 'short',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                });

                const timeStr = date.toLocaleTimeString("en-US", {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
                });

                return `${dateStr} ${timeStr}`;
            }
        },        
        onCancel(){
            this.mangeUserAddDialog = false
            this.addUser =  {
                valid: true,
                username:'',
                first_name: '',
                last_name: '',
                is_staff: false,
                email: '',
                is_portal_user: true,
            }

        },
        showEditUserDialog(data) {              
            if(this.isStaff === false)
            {
                this.showErrorDialog(i18n.t('MANAGEUSERS.ERROR_2'))
                return
            }
            this.mangeUserEditDialog = true;
            this.editUser.first_name = data.first_name;
            this.editUser.last_name = data.last_name;
            this.editUser.email = data.email;
            this.editUser.is_staff = data.is_staff
            this.editUser.id = data.id
            this.editUser.is_portal_user = data.usersetting ? data.usersetting.is_portal_user : false;
        },
        async onUserEdit(data) {
            if(this.validateForm()){
                this.changeData=this.mangeUserListData.filter(user=>{return user.id==data.id})[0]

                let tenant = window.localStorage.getItem('tenant');
                let localUserData = JSON.parse(window.localStorage.getItem('user'));

                data.usersetting = { is_portal_user: data.is_portal_user };
                let response = await PersonalSettingService.updateUserDetail(data);

                let editUserData = this.mangeUserData.find(el => el == this.changeData)
                editUserData.fullName = response.data.last_name+' '+response.data.first_name
                editUserData.is_staff = response.data.is_staff
                this.changeData.last_name = response.data.last_name
                this.changeData.first_name = response.data.first_name
                this.changeData.email = response.data.email
                this.changeData.is_staff = response.data.is_staff
                if (response.data.usersetting) {
                    this.changeData.usersetting.is_portal_user = response.data.usersetting.is_portal_user;
                }

                if(!response.data.is_staff && (response.data.usersetting.user_id == localUserData.userid)){
                    await this.logout()
                    let redirectTo = (tenant != null || tenant != '') ? `/upgpt-login?tenant=${tenant}` : '/upgpt-login';
                    this.$emit('logoutSuccess');
                    this.$router.push(redirectTo);
                }

                this.mangeUserEditDialog = false;
                let user = JSON.parse(window.localStorage.getItem('user'));
                if( user.userid == data.id && !data.is_staff)
                {
                    window.location.reload();
                }
            }	
        },
        onMail: function (mail) {
            return 'mailto:'+mail;
        },
        rowClass() {        
            const rowClass = 'dataTableColor'
            return rowClass;
        },
        onDelete (item) {
            if(this.isStaff === false)
            {
                this.showErrorDialog(i18n.t('MANAGEUSERS.ERROR_2'))
                return
            }
            this.showMessageDialog(i18n.t('MANAGEUSERS.MESSAGE'));
            this.deleteUser =true
            this.deleteUserID = item.id
            this.deleteItemIndex =  this.mangeUserListData.indexOf(item);
            this.deleteData = {id:item.id,is_active:false}
        },
        onReactive(item){
            if(this.isStaff === false)
            {
                this.showErrorDialog(i18n.t('MANAGEUSERS.ERROR_2'))
                return
            }
            this.showMessageDialog(i18n.t('MANAGEUSERS.MESSAGE_2'));
            this.reActiveUser = true
            this.reActiveUserID = item.id
            this.reActiveItemIndex =  this.mangeUserListData.indexOf(item);
            this.reActiveData = {id:item.id,is_active:true}            
        },
        isActiveAgent(item){
            item.usersetting.status = 'OFFLINE';
            PersonalSettingService.updateDetail(item.id, item)
            .then(response => {
                // get data from local storage
                let userJson = window.localStorage.getItem('user');
                let user = JSON.parse(userJson);

                if(user.userid == response.data.id){
                    // set data to local storage
                    user.is_service_agent = response.data.usersetting.is_service_agent;
                    user.is_portal_user = response.data.usersetting.is_portal_user;
                    user.status = response.data.usersetting.status;
                    window.localStorage.setItem('user', JSON.stringify(user));
                    passData.$emit("menuBarAgentData", user);
                }
            })
            .catch(response => {
                this.showErrorDialog(response);
            })
        }
        }
    });
</script>